import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

import { getRegPath } from "../../../constants";
import * as actions from "../../../store/actions/";
import { VALIDATE_FOROGOT_PASSWORD } from "../../../store/actions/actionTypes";

import Row from "../../../components/uiElements/grid/Row";
import Button from "../../../components/formElements/button/Button";
import TextInput from "../../../components/formElements/input/TextInput";
import SpinnerBorder from "../../../components/uiElements/loadingSpinner/SpinnerBorder";

const ForgotPassword = ({
  forgotPasswordData,
  setForgotPasswordData,
  forgotPasswordRequest,
  form,
  validateData,
  history,
  apiUtil,
}) => {
  const [linkSent, setLinkSent] = useState(false);

  useEffect(() => {
    if (form && form.forgotPasswordValid) {
      forgotPasswordRequest(() => {
        setLinkSent(true);
        form.forgotPasswordValid = false;
      });
    }
    // eslint-disable-next-line
  }, [form]);

  return (
    <div className="container" style={{ marginTop: "10%", maxWidth: 400 }}>
      <h2 className="auth-header mb-5">
        Forgot
        <br /> Password
      </h2>
      {!linkSent && (
        <p className="mb-5">
          Please enter your registered email id. <br />
          We will send a link to reset your password
        </p>
      )}
      <Row>
        <div
          className="col-md-12 text-left mt-4"
          onKeyDown={event => {
            if (event.keyCode === 13) {
              validateData(forgotPasswordData);
            }
          }}
        >
          {!linkSent ? (
            <TextInput
              error={form.forgotPasswordEmail}
              type="text"
              label="Email Id"
              value={forgotPasswordData.forgotPasswordEmail}
              onChange={val =>
                setForgotPasswordData({ forgotPasswordEmail: val })
              }
            />
          ) : (
            <div
              style={{ backgroundColor: "#333333", color: "white", padding: 5 }}
              className="mb-5"
            >
              An email has been sent to the email you have provided. Please
              follow the link in the email to complete your password reset
              request.
            </div>
          )}
        </div>
      </Row>
      <div>
        {!linkSent ? (
          <Button
            label={
              apiUtil.isLoading ? (
                <SpinnerBorder />
              ) : (
                "Request Link to Reset Password"
              )
            }
            className="mb-4"
            onClick={() => validateData(forgotPasswordData)}
          />
        ) : (
          <Button
            label={"Back to Sign In"}
            className="mb-4"
            onClick={() => history.push(getRegPath("/signin"))}
          />
        )}
      </div>
      {!linkSent && (
        <p className="text-center">
          <Link className="link" to={getRegPath("/signin")}>
            Back to Sign In
          </Link>
        </p>
      )}
    </div>
  );
};

const mapStoreToProps = ({ login, validation, api }) => ({
  forgotPasswordData: login,
  form: validation.data,
  apiUtil: api,
});

const mapDispatchToProps = dispatch => ({
  setForgotPasswordData: updatedData =>
    dispatch(actions.setLoginData(updatedData)),
  validateData: forgotPasswordData =>
    dispatch(
      actions.validateData(VALIDATE_FOROGOT_PASSWORD, forgotPasswordData)
    ),
  forgotPasswordRequest: cb => dispatch(actions.forgotPasswordRequest(cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(ForgotPassword)
);
